import { Box, Button, Currency, Text } from "@vinomofo/components";
import { useEffect, useRef, useState } from "react";

import { AfterpayPlacement } from "../afterpay-placement";
import { CloseIcon } from "@vinomofo/icons";
import { PayPal4Placement } from "../paypal-pay-4-placement";
import styled from "styled-components";

interface PayLaterWrapperProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  currency: string;
  locale: string;
  amount: number;
}

const PayLaterWrapperBox = styled(Box)`
  color: #626468;
  text-align: center;
`;

const ButtonsWrapperBox = styled<{ visible?: boolean }>(Box)`
  display: ${({ visible }) => (visible ? "block" : "none")};
  color: #626468;
`;

export const PayLaterWrapper: React.FC<PayLaterWrapperProps> = ({
  locale,
  amount,
  currency,
}) => {
  const [showButtons, setShowButtons] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const afterpayElement = document.getElementsByTagName(
        "afterpay-modal"
      )[0];
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node) &&
        afterpayElement &&
        !(event.target === afterpayElement)
      ) {
        setShowButtons(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <PayLaterWrapperBox py={2} position="relative" ref={wrapperRef}>
      <Text variant="sm" fontSize={0}>
        Or 4 payments of{" "}
        <strong>
          <Currency amount={amount / 4} includeFraction superFraction={false} />
        </strong>{" "}
        with our{" "}
        <span
          onClick={() => setShowButtons(!showButtons)}
          style={{ cursor: "pointer", textDecoration: "underline" }}
        >
          buy now pay later
        </span>{" "}
        providers.
      </Text>
      <ButtonsWrapperBox
        visible={showButtons}
        p={2}
        mt={1}
        width="100%"
        borderRadius={4}
        border="1px solid"
        position="relative"
        borderColor="#9e9e9e"
        backgroundColor="white"
      >
        <Box
          position="absolute"
          top="-8px"
          right="-8px"
          borderRadius="100%"
          backgroundColor="white"
          height="17px"
          width="17px"
        >
          <Button
            disabled={!showButtons}
            onClick={() => setShowButtons(!showButtons)}
            data-testid="close-pay-later-wrapper"
            color="deal"
            height="17px"
            width="17px"
            hoverColor="deal"
          >
            <CloseIcon size="18px" />
          </Button>
        </Box>
        <Text variant="sm" fontSize={0}>
          To learn more, click on any of the providers below.
        </Text>
        <br />
        <AfterpayPlacement
          locale={locale}
          currency={currency}
          amount={amount}
        />
        <PayPal4Placement amount={amount} />
      </ButtonsWrapperBox>
    </PayLaterWrapperBox>
  );
};
